export const SERVICE_NAME = 'Yandex Forms';

export enum GatewayInstallation {
    Russia = 'russia',
    Israel = 'israel',
    YaTeam = 'yandex-team',
    NoType = 'notype',
}

export enum GatewayEnv {
    Prod = 'prod',
    Preprod = 'preprod',
    NoEnv = 'noenv',
}

export enum AppInstallation {
    Anonymous = 'anonymous',
    Business = 'business',
    External = 'external',
    Internal = 'internal',
    Preview = 'preview',
}

export enum Header {
    xUseCollab = 'x-use-collab',
    AcceptLanguage = 'accept-language',
    ContentType = 'content-type',
    ContentLength = 'content-length',
    xFrontendAuthorization = 'x-frontend-authorization',
    ContentSecurityPolicy = 'content-security-policy',
    xFormReferer = 'x-form-referer',
    xFormParent = 'x-form-parent',
    xSurveyId = 'x-survey-id',
    xFormsYandexUid = 'x-forms-yandexuid',
    xCSRFToken = 'x-csrf-token',
    Authorization = 'authorization',
    Cookie = 'cookie',
}

export enum ExperimentKey {
    Com = '_com',
    ComForce = '_com_force',
    YaRu = '_ya_ru',
    NewUi = '_new_ui',
    NewUiAll = '_new_ui_all',
    NewUiForce = '_new_ui_force',
    SafariItp = '_safari_itp',
    DisableCsrf = '_disable_csrf',
    formsYandexUid = '_forms_yandexuid',
    Render404ErrorFiles = '_render_404_error_files',
}

export const YandexRU = 'https://yandex.[tld]';
export const YaRU = 'https://ya.ru';

export const enabledExperiment = '1';

export enum Lang {
    Ru = 'ru',
    En = 'en',
    Uk = 'uk',
    Be = 'be',
    Kk = 'kk',
}

export enum ErrorLayoutType {
    Unknown = '500',
    NotFound = 'not_found',
    NotPublished = 'not_published',
    NotPermitted = 'not_permitted',
    OnlyInIframe = 'only_in_iframe',
    AlreadyAnswered = 'already_answered',
    AccessDenied = 'access_denied',
    CookiesNotAvailable = 'cookies_not_available',
    RoleError = 'role_error',
}

export enum Theme {
    System = 'system',
    Dark = 'dark',
    Light = 'light',
    LightHC = 'light-hc',
    DarkHC = 'dark-hc',
}

export const newUiQueryKey = '_dataui_interface';
export const newUiQueryValues = ['create', 'preview'];

export const cookieEnabledFlag = 'cookieon';
